import { render, staticRenderFns } from "./promt.vue?vue&type=template&id=fcfa1e06&scoped=true&"
import script from "./promt.vue?vue&type=script&lang=js&"
export * from "./promt.vue?vue&type=script&lang=js&"
import style0 from "./promt.vue?vue&type=style&index=0&id=fcfa1e06&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcfa1e06",
  null
  
)

export default component.exports